<template>
  <div style="background: #4953cf;">
    <div class="header-content">
      <div>
        <span>用电记录</span>
      </div>
      <div style="text-align: center;margin-top: 20px;">
        <span class="dorm-text">{{dormName}}</span>
        <!-- <span class="dorm-text">02号学生公寓02202</span> -->
      </div>
      <div @click="showMonthPicker" style="font-size: 20px;display: flex;justify-content: center;align-items: center;flex-direction: column;">
        {{year}}年{{month + 1}}月
        <img style="height: 20px;" src="../assets/change.png"/>
      </div>
      <!-- <div style="text-align: center;margin-top: 40px;">
        <button style="border-radius: 20px 0px 0px 20px;" class="recharge-btn" v-bind:class="{ active : type == '充值完成'}" @click="() => chooice('充值完成')">充值完成</button>
        <button style="border-radius: 0px 20px 20px 0px;" class="recharge-btn" v-bind:class="{ active : type == '充值中'}" @click="() => chooice('充值中')">充值中</button>
      </div> -->
    </div>
    <div class="fee-content">
      <div v-if="!list || list.length == 0" style="text-align: center;font-weight: 700;padding-top: 100px;">
        无充值记录
      </div>
      <div v-if="list && list.length">
        <div v-for="item in list" v-bind:key="item.id" class="weui-media-box weui-media-box_text weight">
          <!-- <h4 class="weui-media-box__title">{{item.date}}</h4> -->
          <p style="float: right" class="weui-media-box__desc">-{{item.dayAmp.toFixed(2)}}度</p>
          <p class="weui-media-box__desc">{{item.date.getFullYear()}}年{{item.date.getMonth() + 1}}月{{item.date.getUTCDate()}}日</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapState } from 'vuex'
import weui from 'weui.js'
import moment from 'moment'
import RoomApi from  '@/api/src/room/api/RoomApi'
const roomApi = new RoomApi()
export default {
  name: 'UseHistory',
  data() {
    let date = moment()
    return {
      type: '充值完成',
      year: date.year(),
      month: date.month(),
      list: []
    }
  },
  computed: mapState({
    dormName: state => state.user.currentUser.loudong + state.user.currentUser.room,
    userName: state => state.user.currentUser.name,
    roomId: state => state.user.currentUser.roomId
  }),
  created() {
    this.getData()
  },
  methods: {
    async getData() {
      let month = moment([this.year, this.month, 1])
      let resp = await roomApi.useHistory(this.roomId, month.format('YYYY-MM-DD'))
      for(let i = 0; i < resp.length; i++){
        resp[i].dayAmp = 0
        if(resp[i - 1]){
          resp[i].dayAmp = resp[i].usedAmp - resp[i - 1].usedAmp
        }
      }
      this.list = resp
    },
    showMonthPicker() {
      // weui.datePicker({
      //   start: 2021,
      //   end: new Date().getFullYear(),
      //   onChange: function (result) {
      //       console.log(result);
      //   },
      //   onConfirm: function (result) {
      //       console.log(result);
      //   },
      //   title: '多列选择器'
      // });
      const start = 2021
      let end = new Date().getFullYear()
      let yearList = []
      for(let i = start; i <= end; i++){
        let year = {
          value: i,
          label: `${i}年`,
          children: []
        }
        for(let j = 1; j <= 12; j++){
          year.children.push({
            value: j,
            label: `${j}月`
          })
        }
        yearList.push(year)
      }
      weui.picker(yearList, {
        onConfirm: (result) => {
            console.log(result);
            this.year = result[0].value
            this.month = result[1].value - 1
            this.getData()
        },
      })
    }
  }
}
</script>

<style scoped>
  .header-content{
    background: #4953cf;
    min-height: 130px;
    color: white;
    padding: 30px;
  }
  .header-content span{
    font-weight: 600;
  }
  .dorm-text{
    font-size: 30px;
  }
  .dorm-mesage{
    text-align: center;
    font-size: 16px;
    margin-top: 20px;
    font-weight: 600;
  }
  .project{
    margin-top: 30px;
    background: white;
    color: #000;
    border-radius: 20px;
    text-align: center;
  }
  .project-main-text{
    color: #4b52aa;
    font-size: 18px;
    font-weight: 500;
    height: 70px;
    line-height: 70px;
  }
  .fee-content{
    border-radius: 20px 20px 0px 0px;
    background: white;
  }
  .fee-content-1{
    padding: 40px 20px 20px 20px;
  }
  .recharge-btn{
    height: 40px;
    width: 50%;
    background: white;
    color: #363fa3;
    font-weight: 500;
    font-size: 18px;
    border: 0px;
  }
  .active{
    background: #f1f1f1;
  }
  .weight{
    font-weight: 700;
  }
  .weight h4{
    font-weight: 700;
  }
</style>